import React, {useEffect, useRef, useState} from 'react';

import Box from "@mui/material/Box";
import {Alert, InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getAccounts,
    getAmountTypes,
    getFinancialMarkets,
    getLanguageCodes,
    getSourceSystems, getTerritories
} from "./FinancialClient";
import {changeFinancial} from "./financialSlice";
import {changeFinancialSearch} from "./financialSearchSlice";
import {getLicensees} from "../License/LicenseClient";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import Snackbar from "@mui/material/Snackbar";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function FinancialSearch({gridClear}) {

    const { register, handleSubmit, setValue, reset, control } = useForm();

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const [accountDropdown, setAccountDropdown] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [amountTypeDropdown, setAmountTypeDropdown] = useState([]);
    const [selectedAmountType, setSelectedAmountType] = useState('');
    const [financialMarketDropdown, setFinancialMarketDropdown] = useState([]);
    const [selectedFinancialMarket, setSelectedFinancialMarket] = useState('');
    const [territoryDropdown, setTerritoryDropdown] = useState([]);
    const [selectedTerritory, setSelectedTerritory] = useState('');
    const [languageCodeDropdown, setLanguageCodeDropdown] = useState([]);
    const [selectedLanguageCode, setSelectedLanguageCode] = useState('');
    const [licenseeDropdown, setLicenseeDropdown] = useState([]);
    const [selectedLicensee, setSelectedLicensee] = useState('');
    const [sourceSystemDropdown, setSourceSystemDropdown] = useState([]);
    const [selectedSourceSystem, setSelectedSourceSystem] = useState('');
    const setupsDropdown = ["","Has","None"];
    const [selectedParticipations, setSelectedParticipations] = useState('');
    const [selectedResiduals, setSelectedResiduals] = useState('');
    const [selectedRoyalties, setSelectedRoyalties] = useState('');
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [financialValue, setFinancialValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [financials, setFinancials] = useState([]);

    const handleClearClick = () => {
        setFinancialValue("");
    };

    const handleClearFinancialClick = () => {
        setFinancialValue("");
    };


    const handleClear = () => {
        console.log("This is for the clear button");
        reset({
            fileId: '',
            propertyId: '',
            productName: '',
            episodeName: '',
            photoStartDateFrom:  '',
            photoStartDateTo:  '',
            seriesExternalId:  '',
            seriesName:  '',
            seasonExternalId:  '',
            seasonNumberFrom:  '',
            seasonNumberTo:  '',
            seasonName:  '',
            account:  '',
            amountFrom:  '',
            amountTo:  '',
            amountType:  '',
            financialMarket:  '',
            territory:  '',
            languageCode:  '',
            licenseId:  '',
            licensee:  '',
            periodEndDateFrom:  '',
            periodEndDateTo:  '',
            sourceSystem:  '',
            sourceSystemIdFrom:  '',
            sourceSystemIdTo:  '',
            unitsFrom:  '',
            unitsTo:  '',
            idFrom:  '',
            idTo:  '',
            adjustBeginFrom:  '',
            adjustBeginTo:  '',
            adjustEndFrom:  '',
            adjustEndTo:  '',
            adjustNote:  '',
            stakeholderId:  '',
            contractId:  '',
            participations:  '',
            residuals:  '',
            royalties:  ''
        });

        setSelectedAccount('');
        setSelectedAmountType('');
        setSelectedFinancialMarket('');
        setSelectedTerritory('');
        setSelectedLanguageCode('');
        setSelectedLicensee('');
        setSelectedSourceSystem('');
        setSelectedParticipations('');
        setSelectedResiduals('');
        setSelectedRoyalties('');

        gridClear()
    };

    const fetchAccounts = () =>
        getAccounts()
            .then(data => {
                console.log("M4Mkt Groups");
                console.log(data);
                console.log("M4Mkt Groups with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setAccountDropdown(data);
            });

    const fetchAmountTypes = () => {
        getAmountTypes()
            .then(data => {
                console.log("Initial Markets");
                console.log(data);
                console.log("Initial Markets with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setAmountTypeDropdown(data);
            })}


    const fetchFinancialMarkets = () =>
        getFinancialMarkets()

            .then(data => {
                console.log("FinancialMarkets");
                console.log(data);
                console.log("FinancialMarkets with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setFinancialMarketDropdown(data);
            })

    const fetchTerritories = () =>
        getTerritories()

            .then(data => {
                console.log("Production Types");
                console.log(data);
                console.log("Production Types with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setTerritoryDropdown(data);
            })

    const fetchLanguageCodes = () =>
        getLanguageCodes()

            .then(data => {
                console.log("LanguageCodes");
                console.log(data);
                console.log("LanguageCodes with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setLanguageCodeDropdown(data);
            })


    const fetchLicensees = () =>
        getLicensees()

            .then(data => {
                console.log("Licensees");
                console.log(data);
                console.log("Licensees with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setLicenseeDropdown(data);
            })

    const fetchSourceSystems = () =>
        getSourceSystems()
            .then(data => {
                console.log("Source Systems");
                console.log(data);
                console.log("Source Systems with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setSourceSystemDropdown(data);
            })

    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchAccounts();
        fetchAmountTypes();
        fetchFinancialMarkets();
        fetchTerritories();
        fetchLanguageCodes();
        fetchLicensees();
        fetchSourceSystems();
    }, []);


    function onSubmit(data) {
        console.log("here's my financial search data before I submit it ")
        console.log({data});
        dispatchData(changeFinancialSearch({
            fileId: data.fileId,
            propertyId: data.propertyId,
            productName: data.productName,
            episodeName: data.episodeName,
            photoStartDateFrom: data.photoStartDateFrom,
            photoStartDateTo: data.photoStartDateTo,
            seriesExternalId: data.seriesExternalId,
            seriesName: data.seriesName,
            seasonExternalId: data.seasonExternalId,
            seasonNumberFrom: data.seasonNumberFrom,
            seasonNumberTo: data.seasonNumberTo,
            seasonName: data.seasonName,
            account: data.account,
            amountFrom: data.amountFrom,
            amountTo: data.amountTo,
            amountType: data.amountType,
            financialMarket: data.financialMarket,
            territory: data.territory,
            languageCode: data.languageCode,
            licenseId: data.licenseId,
            licensee: data.licensee,
            periodEndDateFrom: data.periodEndDateFrom,
            periodEndDateTo: data.periodEndDateTo,
            idFrom: data.idFrom,
            idTo: data.idTo,
            sourceSystem: data.sourceSystem,
            sourceSystemId: data.sourceSystemId,
            unitsFrom: data.unitsFrom,
            unitsTo: data.unitsTo,
            adjustBeginFrom: data.adjustBeginFrom,
            adjustBeginTo: data.adjustBeginTo,
            adjustEndFrom: data.adjustEndFrom,
            adjustEndTo: data.adjustEndTo,
            adjustNote: data.adjustNote,
            stakeholderId: data.stakeholderId,
            contractId: data.contractId,
            participations: data.participations,
            residuals: data.residuals,
            royalties: data.royalties
        }));
        dispatchData(changeFinancial({
            financialGridRefresh: true
        }));
    };



    const handleAccountChange = (accountEvent) => {
        setSelectedAccount(accountEvent.target.value);
        console.log("This is for the selected Value");
        console.log(accountEvent.target.value);
    };

    const handleAmountTypeChange = (amountTypeEvent) => {
        setSelectedAmountType(amountTypeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(amountTypeEvent.target.value);
    };

    const handleFinancialMarketChange = (financialMarketEvent) => {
        setSelectedFinancialMarket(financialMarketEvent.target.value);
        console.log("This is for the selected Value");
        console.log(financialMarketEvent.target.value);
    };

    const handleTerritoryChange = (territoryEvent) => {
        setSelectedTerritory(territoryEvent.target.value);
        console.log("This is for the selected Value");
        console.log(territoryEvent.target.value);
    };

    const handleLanguageCodeChange = (languageCodeEvent) => {
        setSelectedLanguageCode(languageCodeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(languageCodeEvent.target.value);
    };

const handleLicenseeChange = (licneseeEvent) => {
    setSelectedLicensee(licneseeEvent.target.value);
    console.log("This is for the selected Value");
    console.log(licneseeEvent.target.value);
};

    const handleSourceSystemChange = (sourceSystemEvent) => {
        setSelectedSourceSystem(sourceSystemEvent.target.value);
        console.log("This is for the selected Value");
        console.log(sourceSystemEvent.target.value);
    };

    const handleParticipationsChange = (participationsEvent) => {
        setSelectedParticipations(participationsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(participationsEvent.target.value);
    };

    const handleResidualsChange = (residualsEvent) => {
        setSelectedResiduals(residualsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(residualsEvent.target.value);
    };

    const handleRoyaltiesChange = (royaltiesEvent) => {
        setSelectedRoyalties(royaltiesEvent.target.value);
        console.log("This is for the selected Value");
        console.log(royaltiesEvent.target.value);
    };

    const handleClearAccount = () => {
        setSelectedAccount("");}


    const selectR2mRef = useRef();

    const onClear = () => {
        // selectR2mRef.current.select.clearValue();
        // selectR2mRef.Clear;
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 480, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('fileId', {required: false})}
                               id="fileId" name="fileId" label="File ID" aria-describedby="fileId_entry"
                               sx={{width: 120, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('propertyId', { required: false })}
                               id="propertyId"   name="propertyId"  label="Property ID" aria-describedby="propertyId_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('productName', { required: false })}
                               id="productName"   name="productName"  label="Product Name" aria-describedby="productName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('episodeName', { required: false })}
                               id="episodeName"   name="episodeName"  label="Episode Name" aria-describedby="episodeName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <FormDatePicker
                        name="photoStartDateFrom"
                        label="Photo From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="photoStartDateTo"
                        label="Photo To"
                        control={control}
                        width={200}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateFrom', { required: false })}*/}
                    {/*           id="photoStartDateFrom"   name="photoStartDateFrom"  label="Photo From" aria-describedby="photoStartDateFrom_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateTo', { required: false })}*/}
                    {/*           id="photoStartDateTo"   name="photoStartDateTo"  label="Photo To" aria-describedby="photoStartDateTo_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('seriesExternalId', { required: false })}
                               id="seriesExternalId"   name="seriesExternalId"  label="Series ID" aria-describedby="seriesExternalId_entry"
                               sx={{ width:120, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seriesName', { required: false })}
                               id="seriesName"   name="seriesName"  label="Series Name" aria-describedby="seriesName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonExternalId', { required: false })}
                               id="seasonExternalId"   name="seasonExternalId"  label="Season ID" aria-describedby="seasonExternalId_entry"
                               sx={{ width: 160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberFrom', { required: false })}
                               id="seasonNumberFrom"   name="seasonNumberFrom"  label="# From" aria-describedby="seasonNumberFrom_entry"
                               sx={{ width: 120, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberTo', { required: false })}
                               id="seasonNumberTo"   name="seasonNumberTo"  label="# To" aria-describedby="seasonNumberTo_entry"
                               sx={{ width: 120, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonName', { required: false })}
                               id="seasonName"   name="seasonName"  label="Season Name" aria-describedby="seasonName_entry"
                               sx={{ width: 400 }} />
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>

                    <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="account">Account</InputLabel>
                        <Select
                            {...register('account', { required: false })}
                            labelId="demo-simple-select-filled-account"
                            id="account"
                            FreeSolo={true}
                            variant="filled"
                            label="account"
                            value={selectedAccount}
                            onChange={handleAccountChange}
                            sx={{ width: 300}}
                        >
                            {accountDropdown.map((accountItem) =>
                                <MenuItem  FreeSolo={true} value={accountItem.singleField}  key={accountItem.singleField}
                                >{accountItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField variant="filled"
                               {...register('amountFrom', { required: false })}
                               id="amountFrom"   name="amountFrom"  label="Amount From" aria-describedby="amountFrom_entry"
                               sx={{ width: 180, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('amountTo', { required: false })}
                               id="amountTo"   name="amountTo"  label="Amount To" aria-describedby="amountTo_entry"
                               sx={{ width: 180, pr: 5 }} />
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="amountType">Amount Type</InputLabel>
                        <Select
                            {...register('amountType', { required: false })}
                            labelId="demo-simple-select-filled-amountType"
                            id="amountType"
                            FreeSolo={true}
                            variant="filled"
                            label="amountType"
                            value={selectedAmountType}
                            onChange={handleAmountTypeChange}
                            sx={{ width: 300}}
                        >
                            {amountTypeDropdown.map((amountTypeItem) =>
                                <MenuItem  FreeSolo={true} value={amountTypeItem.singleField} key={amountTypeItem.singleField}
                                >{amountTypeItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField variant="filled"
                               {...register('unitsFrom', { required: false })}
                               id="unitsFrom"   name="unitsFrom"  label="Units From" aria-describedby="unitsFrom_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('unitsTo', { required: false })}
                               id="unitsTo"   name="unitsTo"  label="Units To" aria-describedby="unitsTo_entry"
                               sx={{ width: 150, pr: 5 }} />
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="financialMarket">Financial Market</InputLabel>
                        <Select
                            {...register('financialMarket', { required: false })}
                            labelId="demo-simple-select-filled-financialMarket"
                            id="financialMarket"
                            FreeSolo={true}
                            variant="filled"
                            label="financialMarket"
                            value={selectedFinancialMarket}
                            onChange={handleFinancialMarketChange}
                            sx={{ width: 200}}
                        >
                            {financialMarketDropdown.map((financialMarketItem) =>
                                <MenuItem  FreeSolo={true} value={financialMarketItem.singleField} key={financialMarketItem.singleField}
                                >{financialMarketItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="territory">Territory</InputLabel>
                        <Select
                            {...register('territory', { required: false })}
                            labelId="demo-simple-select-filled-territory"
                            id="territory"
                            FreeSolo={true}
                            variant="filled"
                            label="territory"
                            value={selectedTerritory}
                            onChange={handleTerritoryChange}
                            sx={{ width: 200}}
                        >
                            {territoryDropdown.map((territoryItem) =>
                                <MenuItem  FreeSolo={true} value={territoryItem.singleField} key={territoryItem.singleField}
                                >{territoryItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="languageCode">Language Code</InputLabel>
                        <Select
                            {...register('languageCode', { required: false })}
                            labelId="demo-simple-select-filled-languageCode"
                            id="languageCode"
                            FreeSolo={true}
                            variant="filled"
                            label="languageCode"
                            value={selectedLanguageCode}
                            onChange={handleLanguageCodeChange}
                            sx={{ width: 200}}
                        >
                            {languageCodeDropdown.map((languageCodeItem) =>
                                <MenuItem  FreeSolo={true} value={languageCodeItem.singleField} key={languageCodeItem.singleField}
                                >{languageCodeItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <TextField variant="filled"
                               {...register('licenseId', { required: false })}
                               id="licenseId"   name="licenseId"  label="License ID" aria-describedby="licenseId_entry"
                               sx={{ width: 150, pr: 5 }} />

                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="licensee">Licensee</InputLabel>
                        <Select
                            {...register('licensee', { required: false })}
                            labelId="demo-simple-select-filled-licensee"
                            id="licensee"
                            FreeSolo={true}
                            variant="filled"
                            label="licensee"
                            value={selectedLicensee}
                            onChange={handleLicenseeChange}
                            sx={{ width: 200}}
                        >
                            {licenseeDropdown.map((licenseeItem) =>
                                <MenuItem  FreeSolo={true} value={licenseeItem.singleField} key={licenseeItem.singleField}
                                >{licenseeItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>

                    <FormDatePicker
                        name="periodEndDateFrom"
                        label="Period End From"
                        control={control}
                        width={220}
                    />
                    <FormDatePicker
                        name="periodEndDateTo"
                        label="Period End To"
                        control={control}
                        width={220}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('periodEndDateFrom', { required: false })}*/}
                    {/*           id="periodEndDateFrom"   name="periodEndDateFrom"  label="Period End From" aria-describedby="periodEndDateFrom_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}

                    {/*<TextField variant="filled"*/}
                    {/*           {...register('periodEndDateTo', { required: false })}*/}
                    {/*           id="periodEndDateTo"   name="periodEndDateTo"  label="Period End To" aria-describedby="periodEndDateTo_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}
                    <TextField variant="filled"
                               {...register('idFrom', { required: false })}
                               id="idFrom"   name="idFrom"  label="ID From" aria-describedby="id_from_entry"
                               sx={{ width: 150, pr: 5 }} />

                    <TextField variant="filled"
                               {...register('idTo', { required: false })}
                               id="idTo"   name="idTo"  label="ID To" aria-describedby="Id_to_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="sourceSystem">Source System</InputLabel>
                        <Select
                            {...register('sourceSystem', { required: false })}
                            labelId="demo-simple-select-filled-sourceSystem"
                            id="sourceSystem"
                            FreeSolo={true}
                            variant="filled"
                            // value={selectedAccount}
                            value={selectedSourceSystem}
                            label="sourceSystem"
                            onChange={handleSourceSystemChange}
                            sx={{ width: 200}}
                        >
                            {sourceSystemDropdown.map((sourceSystemItem) =>
                                <MenuItem  FreeSolo={true} value={sourceSystemItem.singleField} key={sourceSystemItem.singleField}
                                >{sourceSystemItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField variant="filled"
                               {...register('sourceSystemId', { required: false })}
                               id="sourceSystemId"   name="sourceSystemId"  label="Source System ID" aria-describedby="sourceSystemId_entry"
                               sx={{ width: 230, pr: 5 }} />

                    {/*<TextField variant="filled"*/}
                    {/*           {...register('sourceSystemIdTo', { required: false })}*/}
                    {/*           id="sourceSystemIdTo"   name="sourceSystemIdTo"  label="Source System ID To" aria-describedby="sourceSystemIdTo_entry"*/}
                    {/*           sx={{ width: 230, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>

                    <FormDatePicker
                        name="adjustBeginFrom"
                        label="Adjustment Begin From"
                        control={control}
                        width={260}
                    />
                    <FormDatePicker
                        name="adjustBeginTo"
                        label="Adjustment Begin To"
                        control={control}
                        width={260}
                    />
                    <FormDatePicker
                        name="adjustEndFrom"
                        label="Adjustment End From"
                        control={control}
                        width={260}
                    />
                    <FormDatePicker
                        name="adjustEndTo"
                        label="Adjustment End To"
                        control={control}
                        width={260}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('adjustBeginFrom', { required: false })}*/}
                    {/*           id="adjustBeginFrom"   name="adjustBeginFrom"  label="Adjustment Begin From" aria-describedby="adjustBeginFrom_entry"*/}
                    {/*           sx={{ width: 240, pr: 5 }} />*/}

                    {/*<TextField variant="filled"*/}
                    {/*           {...register('adjustBeginTo', { required: false })}*/}
                    {/*           id="adjustBeginTo"   name="adjustBeginTo"  label="Adjustment Begin To" aria-describedby="adjustBeginToentry"*/}
                    {/*           sx={{ width: 240, pr: 5 }} />*/}

                    {/*<TextField variant="filled"*/}
                    {/*           {...register('adjustEndFrom', { required: false })}*/}
                    {/*           id="adjustEndFrom"   name="adjustEndFrom"  label="Adjustment End From" aria-describedby="adjustEndFrom_entry"*/}
                    {/*           sx={{ width: 240, pr: 5 }} />*/}

                    {/*<TextField variant="filled"*/}
                    {/*           {...register('adjustEndTo', { required: false })}*/}
                    {/*           id="adjustEndTo"   name="adjustEndTo"  label="Adjustment End To" aria-describedby="adjustEndTo_entry"*/}
                    {/*           sx={{ width: 240, pr: 5 }} />*/}

                    <TextField variant="filled"
                               {...register('adjustNote', { required: false })}
                               id="adjustNote"   name="adjustNote"  label="Adjustment Note" aria-describedby="adjustNote_entry"
                               sx={{ width: 240, pr: 5 }} />
                {/*</Stack>*/}
                {/*<Stack direction={"Horizontal"}  sx={{ pb: 2 }}>*/}

                    <TextField variant="filled"
                               {...register('stakeholderId', { required: false })}
                               id="stakeholderId"   name="stakeholderId"  label="Stakeholder" aria-describedby="stakeholderId_entry"
                               sx={{ width: 240, pr: 5 }} />

                    <TextField variant="filled"
                               {...register('contractId', { required: false })}
                               id="contractId"   name="contractId"  label="Contract ID" aria-describedby="contractId_entry"
                               sx={{ width: 240, pr: 5 }} />


                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>
                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>

            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

